import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {

  @ViewChild('chatContainer') chatContainer?: ElementRef;
  @ViewChild('senderText') senderText?: ElementRef;

  isOpen: boolean = false;
  mensagens: Array<mensagem> = [];

  text: string = "";

  constructor(public userService: UserService, private router: Router, private cdRef: ChangeDetectorRef, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
  }

  swalCheck() {
    if (Swal.isVisible() !== undefined) {
      if (Swal.isVisible()) {
        return true;
      }
    }
    return false;
  }

  bypass(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  getTime() {
    const d = new Date();
    return d.getHours().toString().padStart(2, "0") + ":" + d.getMinutes().toString().padStart(2, "0");
  }

  openChat() {
    this.isOpen = true;
    this.cdRef.detectChanges();
    if (this.chatContainer) {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
      this.senderText?.nativeElement.focus()
    }
  }

  envio(args) {
    this.userService
      .chat(args)
      .subscribe(
        (res: any) => {
          res.messages.forEach((value: any) => {
            switch (value.type) {
              case "text":
                this.mensagens.push(
                  {
                    time: this.getTime(),
                    message: this.bypass(value.text) as string,
                    type: 0,
                    actions: [],
                    action_chosen: -1,
                    callback_id: value.callback_id
                  })
                if (value.callback_id == 'textarea') {
                  if (Swal.isVisible() === undefined || Swal.isVisible() === false) {
                    Swal.fire({
                      width: 800,
                      title: 'Suporte TaxSuite',
                      input: 'textarea',
                      showCancelButton: true,
                      confirmButtonText: 'Enviar',
                      cancelButtonText: 'Cancelar',
                      inputAttributes: {
                        autocapitalize: 'off',
                        placeholder: 'Escreva sua Mensagem'
                      },
                      heightAuto: true,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal',
                        cancelButton: 'btn-swal-cancel'
                      },
                      preConfirm: (value) => {
                        if (value.length === 0) {
                          Swal.showValidationMessage(
                            'A Mensagem não pode ficar em branco'
                          )
                        } else {
                          if (value.length < 30) {
                            Swal.showValidationMessage(
                              'A Mensagem não pode ter menos de 30 caracteres'
                            )
                          }
                        }
                      },
                    }).then((result) => {
                      if (result.isConfirmed) {
                        let text = ((result.value!) as unknown) as string;
                        this.mensagens.push(
                          {
                            time: this.getTime(),
                            message: this.bypass(text.replace(/(?:\r|\n|\r\n)/g, '<br>')) as string,
                            type: 1,
                            actions: [],
                            action_chosen: -1,
                            callback_id: 'textarea'
                          })

                        this.cdRef.detectChanges();
                        if (this.chatContainer) {
                          this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
                        }

                        this.envio({ driver: 'web', userId: this.userService.getToken(), message: text.replace(/(?:\r|\n|\r\n)/g, '<br>'), attachment: 'null', interactive: '0', callback_id: 'textarea' })
                      } else {
                        this.mensagens.push(
                          {
                            time: this.getTime(),
                            message: this.bypass('Cancelar') as string,
                            type: 1,
                            actions: [],
                            action_chosen: -1,
                            callback_id: 'textarea'
                          })

                        this.cdRef.detectChanges();
                        if (this.chatContainer) {
                          this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
                        }

                        this.envio({ driver: 'web', userId: this.userService.getToken(), message: 'Cancelar', attachment: 'null', interactive: '0', callback_id: 'cancelar' })
                      }
                    });
                  }
                }
                break;
              case "actions":
                let actions: Array<action> = []
                value.actions.forEach((value: any) => {
                  actions.push({
                    "text": value.text,
                    "value": value.value
                  })
                });
                this.mensagens.push(
                  {
                    time: this.getTime(),
                    message: this.bypass(value.text) as string,
                    type: 0,
                    actions,
                    action_chosen: -1,
                    callback_id: value.callback_id
                  })
                break;
            }
          })

          this.cdRef.detectChanges();
          if (this.chatContainer) {
            this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
          }
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      );
  }

  enviarMensagem(event: any) {
    event.preventDefault()
    if (this.text.length > 0) {
      this.mensagens.push(
        {
          time: this.getTime(),
          message: this.bypass(this.text) as string,
          type: 1,
          actions: [],
          action_chosen: -1,
          callback_id: 'nothing'
        })

      this.cdRef.detectChanges();
      if (this.chatContainer) {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
      }

      this.envio({ driver: 'web', userId: this.userService.getToken(), message: this.text, attachment: 'null', interactive: '0', callback_id: 'nothing' });

      this.text = "";
    }
  }

  escolherOpcao(msg: mensagem, index: number) {
    const msgIndex = this.mensagens.findIndex(element => element === msg);
    const selectedAction = this.mensagens[msgIndex].actions[index];
    this.mensagens[msgIndex].action_chosen = index;

    this.mensagens.push(
      {
        time: this.getTime(),
        message: selectedAction.text,
        type: 1,
        actions: [],
        action_chosen: -1,
        callback_id: this.mensagens[msgIndex].callback_id
      })

    this.cdRef.detectChanges();
    if (this.chatContainer) {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer?.nativeElement.scrollHeight;
    }

    this.envio({ driver: 'web', userId: this.userService.getToken(), message: selectedAction.value, attachment: 'null', interactive: '1' })
  }
}

export interface mensagem {
  time: string;
  message: string;
  type: number;
  actions: Array<action>
  action_chosen: number;
  callback_id: string;
}

export interface action {
  text: string;
  value: string;
}

